<template>
  <template v-if="isButtonDisplayed">
    <AppTooltip>
      <template #activator="{ props }">
        <app-button
          class="app-button--compact"
          data-locator="description-shortcut-button"
          size="x-small"
          type="icon"
          v-bind="props"
          @click="onOpenChecklistPane"
        >
          <app-material-icon
            name="article"
            color="inherit"
          />
        </app-button>
      </template>
      <span>
        {{ $t('project.checklist.table.ChecklistTableTaskShortcutDescription.buttonTooltip') }}
      </span>
    </AppTooltip>
  </template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'

export default {
  name: 'ChecklistTableTaskShortcutDescription',
  components: {
    AppTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['isChecklistDetailed']),
    isButtonDisplayed () {
      return this.item.description && !this.isChecklistDetailed
    },
  },
  methods: {
    ...mapActions('checklist', [OPEN_CHECKLIST_PANE]),
    onOpenChecklistPane() {
      this.OPEN_CHECKLIST_PANE({
        isOpen: true,
        parent: this.parent,
        tab: 'details',
        tasks: [this.item],
      })
    },
  },
}
</script>

